// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Widgets-ExtractionTabs-module__badge";
var _2 = "webpack-concepts-Extraction-Widgets-ExtractionTabs-module__tab webpack-cssModules-base-module__resetButton";
var _3 = "webpack-concepts-Extraction-Widgets-ExtractionTabs-module__tabList";
var _4 = "webpack-concepts-Extraction-Widgets-ExtractionTabs-module__tabPanel";
var _5 = "webpack-concepts-Extraction-Widgets-ExtractionTabs-module__tabs";
export { _1 as "badge", _2 as "tab", _3 as "tabList", _4 as "tabPanel", _5 as "tabs" }
